if (!customElements.get('section-product')) {
  class TG_SectionProduct extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
      
          this.element = this;
          this.delegateElement = new themegoal.libs.Delegate(this.element);
          this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      
          this.productVariants = new themegoal.components_business.product_variants.ProductVariants(this.element, this.options);
        
          let productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
          let productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');
      
          if (productSlideshowElement) {
            this.productSlideshow = new themegoal.components.Carousel(productSlideshowElement);
          }
      
          if (productSlideshowNavElement) {
            new themegoal.components.Carousel(productSlideshowNavElement);
          }
      
          if (this.options['enableImageZoom']) {
            this.imageZoomInstance = new themegoal.components_business.product_variants.ProductImageModal(this.element);
          }
      
          let styleWithCarouselEle = this.element.querySelectorAll(".ProductStyleWith__Body .ProductList--carousel");
      
          if (styleWithCarouselEle){
            styleWithCarouselEle.forEach(function (ele) {
              new themegoal.components.Carousel(ele);
            });
          }
      
          let offscreenElement = this.element.querySelector('.Site__TopLevelElment');
      
          if (offscreenElement) {
            document.body.appendChild(offscreenElement);
          }
      
          this.blockRecommendationsElementRelated = this.element.querySelector('.ProductBlockRecommendations--related');
      
          if (this.blockRecommendationsElementRelated) {
            this._loadRecommendations();
          }
      
          this.blockRecommendationsElementComplementary = this.element.querySelector('.ProductBlockRecommendations--complementary');
      
          if (this.blockRecommendationsElementComplementary) {
            this._loadRecommendationsComplementary();
          }
      
          this._bindEventsListeners();
        }
      
        _bindEventsListeners() {
          this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
        }
      
      
        _loadRecommendations() {
          var _this = this;
      
          var url = window.routes.productRecommendationsUrl + '?section_id=product-block-recommendations&intent=related&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsRelatedCount'];
      
          return fetch(url).then(function (response) {
            return response.text().then(function (content) {
              var container = document.createElement('div');
              container.innerHTML = content;
      
              let recommendationsElement = _this.element.querySelector('.ProductBlockRecommendations--related .ProductBlockRecommendations__Body');
              
              //has recommend product
              if(container.querySelector('.Carousel__Item')){
                recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".ProductBlockRecommendations__Body").innerHTML;
                new themegoal.components.Carousel(recommendationsElement.querySelector('[data-flickity-config]'));
      
              }else{
                // Show the section
                _this.blockRecommendationsElementRelated.style.display = 'none';
              }
      
            });
          });
        }
      
        _loadRecommendationsComplementary() {
          var _this = this;
      
          var url = window.routes.productRecommendationsUrl + '?section_id=product-block-recommendations&intent=complementary&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsComplementaryCount'];
      
          return fetch(url).then(function (response) {
            return response.text().then(function (content) {
              var container = document.createElement('div');
              container.innerHTML = content;
      
              let recommendationsElement = _this.element.querySelector('.ProductBlockRecommendations--complementary .ProductBlockRecommendations__Body');
              
              //has recommend product
              if(container.querySelector('.Carousel__Item')){
                recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".ProductBlockRecommendations__Body").innerHTML;
                new themegoal.components.Carousel(recommendationsElement.querySelector('[data-flickity-config]'));
      
              }else{
                // Show the section
                _this.blockRecommendationsElementComplementary.style.display = 'none';
              }
      
            });
          });
        }
      
        /**
         * Update the main carousel image
         */
        // _updateSlideshowImage(event) {
        //   var variant = event.detail.variant,
        //       previousVariant = event.detail.previousVariant;
      
        //   if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
        //     return;
        //   }

        //   if (this.options['galleryDesign'] == 'carousel') {
        //     for (var i = 0; i !== this.element.querySelectorAll(".carousel-cell").length; ++i) {
        //       var cellElement = this.element.querySelectorAll(".carousel-cell")[i];
        //       var mediaId = cellElement.getAttribute('data-id');
        //       if (mediaId == variant['featured_media']['id']) {
        //       console.log( variant['featured_media']['id']);
        //        this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
        //       }
        //     }
        //   } 
        
        // }


    _updateSlideshowImage(event) {
    var variant = event.detail.variant,
        previousVariant = event.detail.previousVariant;

    if (!variant || !variant['featured_media'] || (previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id'])) {
        return;
    }

    if (this.options['galleryDesign'] === 'carousel') {
        // Remove 'is-selected' class from all cells
        var cells = this.element.querySelectorAll(".carousel-cell");
        cells.forEach(function(cell) {
            cell.classList.remove('is-selected');
        });

        // Find and select the cell that matches the current variant
        for (var i = 0; i < cells.length; i++) {
            var cellElement = cells[i];
            var mediaId = cellElement.getAttribute('data-id');
            var style= cellElement.getAttribute('style');
            var leftMatch = style.match(/left:\s*([-\d.]+)%/);
    
          
            if (mediaId == variant['featured_media']['id']) {
                console.log(variant['featured_media']['id']);
        
            if (leftMatch) {
            var left =  parseFloat(leftMatch[1]);
            document.querySelector('.flickity-slider').style.transform = `translateX(-${left}%)`;              
            }
                // Add 'is-selected' class to the matching cell
                cellElement.classList.add('is-selected');
                
                break; // Exit the loop once the cell is found and selected
            }
        }
    }
}

    
  }
    
  customElements.define('section-product', TG_SectionProduct);
}

